import React from 'react';
import check from 'custom/img/check@3x.png';
import baseStyles from 'custom/base.styl';

export default () => {
	return <img className={baseStyles.space_bottom} src={check} alt={check} width="72px" />
}



// WEBPACK FOOTER //
// ./src/custom/livres/checkIcon.js